import React, { useState } from 'react'
import { Col, Container, Row, Table, Modal } from 'react-bootstrap'
import { Table as BootstrapTable, Offcanvas } from 'react-bootstrap';
import { FaShoppingCart } from "react-icons/fa";
import { Forms, DropDowns } from '../../components/Forms';
import { Buttons, Close } from '../../components/Buttons/Buttons';
import PageTitle from '../../components/Buttons/PageTitle';
import {
  FaPlay,
  FaTimes,
  FaPlus,
  FaMinus,
  FaQrcode,
  FaCopy,
  FaCheck,
  FaWhatsapp,
  FaFilePdf,
  FaDownload,
} from "react-icons/fa";
import { PDFDownloadLink } from '@react-pdf/renderer';
import '../cardfour/CardFour.css'
import Bill from '../../pdf/Bill';
import { ToastContainer, toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import API_DOMAIN from '../../config/config';
const CardFour = ({ products, category, selectedProduct, totals, addToCart, setShowVideoModal, showVideoModal, updateQuantity, handleShowCart, handleCloseCart, showCart, handleClose, handleShow, show, removeProduct, cart, districtData, companydata, setCart, setting, banner, handleQuantityChange, loading, fetchError, retryFetch }) => {
    const [checkout, setCheckOut] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [modalCopied, setModalCopied] = useState(false);
    const closeOut = () => {
        if (isSubmitting) return;
        setCheckOut(false);
    };
    const showOut = () => setCheckOut(true);
    const [showEstimate, setShowEstimate] = useState(false);
    const closeModal = () => {
        window.location.reload();
        setShowEstimate(false);
    }
    const showModal = () => setShowEstimate(true);
    const [formData, setFormData] = useState({
        state: '',
        city: '',
        name: '',
        email: '',
        mobile: '',
        address: '',
        reference_name: '',
        reference_number: ''
    });
    const [cityOptions, setCityOptions] = useState([]);
    const [printData, setPrintData] = useState([]);
    const [submittedOrder, setSubmittedOrder] = useState(null);

    const getItemDiscount = (item) => {
        if (item.discount !== undefined && item.discount !== null) {
            return item.discount;
        }
        const product = products?.find(p => p.id === item.id);
        if (product) {
            const cat = category?.find(c => c.id === product.category_id);
            if (cat) return cat.discount;
        }
        return 0;
    };
    const handleStateChange = (selectedOption) => {
        const state = selectedOption.value;
        setFormData(prevState => ({
            ...prevState,
            state,
            city: ''
        }));

        const cities = districtData[state] || [];
        setCityOptions(cities.map(city => ({ value: city, label: city })));
    };

    const handleCityChange = (selectedOption) => {
        const city = selectedOption.value;
        setFormData(prevState => ({
            ...prevState,
            city
        }));
    };

    const handleChange = (e, fieldName) => {
        const value = e.target ? e.target.value : e.value;

        setFormData({
            ...formData,
            [fieldName]: value
        });
    };

    const handleSubmit = () => {
        if (isSubmitting) return;

        if (totals.totalProducts === 0 || cart.length === 0) {
            toast.error('Please add products to your cart before submitting order!', {
                position: "top-center",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
            return;
        }

        if (totals.discountRate < 3000) {
            toast.error('Minimum order amount is ₹3000. Please add more items!', {
                position: "top-center",
                autoClose: 2500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
            return;
        }

        if (!formData.mobile || formData.mobile.trim() === '' || !formData.name || formData.name.trim() === "") {
            toast.error('Mobile number and Name cannot be empty!', {
                position: "top-center",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
            return;
        } else {
            setIsSubmitting(true);
            fetch(`${API_DOMAIN}/online_enq_web.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    "cart_pro": cart,
                    "customer_data": formData,
                    "total_products": totals.totalProducts,
                    "total_price": totals.discountRate.toFixed(2),
                    "total_discount": totals.overallTotal.toFixed(2)
                })
            })
                .then(response => {
                    console.log('postdata', JSON.stringify({
                        "cart_pro": cart,
                        "customer_data": formData,
                        "total_products": totals.totalProducts,
                        "total_price": totals.discountRate.toFixed(2),
                        "total_discount": totals.overallTotal.toFixed(2)
                    }))
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json();
                })
                .then(data => {
                    setIsSubmitting(false);
                    if (data.head && data.head.code === 200) {
                        const orderSnapshot = {
                            name: formData.name,
                            mobile: formData.mobile,
                            totalProducts: totals.totalProducts,
                            discountRate: totals.discountRate,
                            overallTotal: totals.overallTotal,
                            enquiryNo: (data.body && data.body.data && (data.body.data.enq || data.body.data.enquiry_id)) || (data.body && data.body.enq) || ''
                        };
                        setSubmittedOrder(orderSnapshot);
                        setPrintData(data.body.data);
                        showModal();
                        setCart([]);
                        setFormData({
                            state: '',
                            city: '',
                            name: '',
                            email: '',
                            mobile: '',
                            address: '',
                            reference_name: '',
                            reference_number: ''
                        });
                        closeOut();
                    } else {
                        const errMsg = (data.body && data.body.msg) || 'Failed to submit order. Please try again.';
                        console.error(errMsg);
                        toast.error(errMsg, {
                            position: "top-center",
                            theme: "colored",
                        });
                    }
                })
                .catch(error => {
                    setIsSubmitting(false);
                    console.error('Error fetching products:', error);
                    toast.error('Failed to submit order. Please check your connection and try again.', {
                        position: "top-center",
                        theme: "colored",
                    });
                });
        }
    };

    const extractVideoId = (url) => {
        const urlObj = new URL(url);
        if (urlObj.hostname === 'youtu.be') {
            return urlObj.pathname.slice(1);
        } else if (urlObj.hostname === 'youtube.com' || urlObj.hostname === 'www.youtube.com') {
            return urlObj.searchParams.get('v') || urlObj.pathname.split('/').pop();
        }
        return '';
    };
    const handleVideoModalShow = () => {
        console.log('Showing video modal');
        setShowVideoModal(true);
    };

    const handleVideoModalClose = () => {
        console.log('Closing video modal');
        setShowVideoModal(false);
    };


    return (
        <>
            <div className=''>
                <Container fluid>
                    <Row>
                        <Col lg='12'>
                            <Row>
                                <Col lg='12' className='px-0'>                                    <div className='w-100 table-four-pricelist stick-top'>
                                    <div className='price-summary-bar d-flex align-items-center justify-content-between px-3 py-2'>
                                        <div className='d-flex align-items-center gap-2'>
                                            <span className='summary-label'>Total Items:</span>
                                            <span className='summary-badge'>{totals.totalProducts}</span>
                                        </div>
                                        <div className='d-none d-md-flex align-items-center gap-2'>
                                            <span className='summary-label'>Net Rate Total:</span>
                                            <span className='summary-value original'>₹ {totals.overallTotal.toFixed(2)}</span>
                                        </div>
                                        <div className='d-flex align-items-center gap-2'>
                                            <span className='summary-label'>Discount Total:</span>
                                            <span className='summary-value discounted'>₹ {totals.discountRate.toFixed(2)}</span>
                                        </div>
                                        <div className='d-flex align-items-center gap-2'>
                                            <a
                                                href="/gmr_crackers_pricelist_2026.pdf"
                                                download="GMR_Crackers_Price_List_2026.pdf"
                                                className="btn btn-warning btn-sm rounded-pill px-3 py-1 bold d-flex align-items-center gap-1 shadow-sm download-nav-btn text-dark text-decoration-none"
                                                title="Download Official 2026 Price List PDF (80% Off)"
                                            >
                                                <FaFilePdf className="text-danger" size={14} />
                                                <span className="d-none d-sm-inline">Price List 2026</span>
                                                <FaDownload className="download-bounce-icon" size={11} />
                                            </a>
                                            <button
                                                type='button'
                                                className='cart-pill-btn'
                                                onClick={handleShowCart}
                                                title='View Cart'
                                            >
                                                <FaShoppingCart />
                                                <span className='d-none d-sm-inline'>Cart</span>
                                                {totals.totalProducts > 0 && (
                                                    <span className='cart-count-bubble'>{totals.totalProducts}</span>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                    <div className='table-responsive fourth-table-container'>
                                        <Table className='mb-0 fourth-table'>
                                            <thead>
                                                <tr className='cardfour-table-header'>
                                                    <th style={{ width: '80px' }} className='text-center'>Img</th>
                                                    <th className='text-start'>Products</th>
                                                    <th style={{ width: '100px' }} className='text-center hide-small'>Content</th>
                                                    <th style={{ width: '100px' }} className='text-center'>Net Rate</th>
                                                    <th style={{ width: '110px' }} className='text-center'>Price</th>
                                                    <th style={{ width: '100px' }} className='text-center'>Qty</th>
                                                    <th style={{ width: '120px' }} className='text-center'>Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {loading && (
                                                    <tr>
                                                        <td colSpan={7} className='text-center py-5'>
                                                            <div className="d-flex flex-column align-items-center justify-content-center">
                                                                <div className="spinner-border text-danger mb-3" style={{ width: '3rem', height: '3rem' }} role="status">
                                                                    <span className="visually-hidden">Loading...</span>
                                                                </div>
                                                                <h5 className="fw-bold text-dark">Loading Crackers & Price List...</h5>
                                                                <p className="text-muted small">Please wait a moment while we fetch the latest prices.</p>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}

                                                {!loading && fetchError && (
                                                    <tr>
                                                        <td colSpan={7} className='text-center py-5'>
                                                            <div className="d-flex flex-column align-items-center justify-content-center">
                                                                <div className="text-danger mb-2" style={{ fontSize: '2rem' }}>⚠️</div>
                                                                <h5 className="fw-bold text-danger">Unable to load products</h5>
                                                                <p className="text-muted small mb-3">Please check your internet connection and try again.</p>
                                                                {retryFetch && (
                                                                    <button className="btn btn-danger px-4 py-2" onClick={retryFetch}>
                                                                        Retry Loading
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}

                                                {!loading && !fetchError && category.length === 0 && (
                                                    <tr>
                                                        <td colSpan={7} className='text-center py-5'>
                                                            <h5 className="fw-bold text-muted">No products available at the moment.</h5>
                                                        </td>
                                                    </tr>
                                                )}

                                                {!loading && category.map((categoryItem) => (
                                                    <React.Fragment key={categoryItem.id}>
                                                        <tr className='category-header-row'>
                                                            <th colSpan={7} className='category-bg'>
                                                                <div className='category-title-wrapper'>
                                                                    <span className='category-title-text'>{categoryItem.category_name}</span>
                                                                    {categoryItem.discount > 0 && (
                                                                        <span className='discount_percentage'>
                                                                            ({categoryItem.discount}% Discount)
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </th>
                                                        </tr>

                                                        {products
                                                            .filter((product) => product.category_id === categoryItem.id)
                                                            .map((product) => {
                                                                const unitPrice = product.discount_lock !== null && product.discount_lock === 0
                                                                    ? (
                                                                        Math.round(product.price -
                                                                            (product.price * categoryItem.discount) / 100)
                                                                    ).toFixed(2)
                                                                    : Math.round(product.price).toFixed(2);

                                                                const lineTotal = (
                                                                    (product.discount_lock !== null && product.discount_lock === 0
                                                                        ? Math.round(product.price -
                                                                            (product.price * categoryItem.discount) / 100)
                                                                        : Math.round(product.price)) * (product.qty || 0)
                                                                ).toFixed(2);

                                                                return (
                                                                    <tr className='product-four-list' key={product.id}>
                                                                        <td className='text-center product-img-cell'>
                                                                            <div className='product-img-wrapper' onClick={() => handleShow(product)} title="View details">
                                                                                <img
                                                                                    src={product.img ? product.img : require('../../assets/images/storelogo.png')}
                                                                                    className='product-thumb-img'
                                                                                    alt={product.product_name}
                                                                                    title={product.product_name}
                                                                                />
                                                                            </div>
                                                                        </td>

                                                                        <td className='text-start product-name-cell'>
                                                                            <div className='cardfour-product-name' onClick={() => handleShow(product)}>
                                                                                {product.product_name}
                                                                            </div>
                                                                            <div className='d-md-none text-muted small mt-1'>
                                                                                {product.product_content}
                                                                            </div>
                                                                        </td>

                                                                        <td className='text-center hide-small product-content-cell'>
                                                                            <span className='product-content-badge'>{product.product_content}</span>
                                                                        </td>

                                                                        <td className='text-center product-netrate-cell'>
                                                                            <div className='netrate'>
                                                                                {product.price}
                                                                            </div>
                                                                        </td>

                                                                        <td className='text-center product-price-cell'>
                                                                            <div className='cardfour-product-name-price'>
                                                                                {unitPrice}
                                                                            </div>
                                                                        </td>

                                                                        <td className='text-center product-qty-cell'>
                                                                            <div className='qty-input-box'>
                                                                                <input
                                                                                    className='card-four-table-input-qty form-control'
                                                                                    type='number'
                                                                                    value={products.find(products => products.id === product.id)?.qty || ''}
                                                                                    min='0'
                                                                                    placeholder='0'
                                                                                    onChange={(e) => handleQuantityChange(product.id, e.target.value, categoryItem.discount)}
                                                                                />
                                                                            </div>
                                                                        </td>

                                                                        <td className='text-center product-total-cell'>
                                                                            <div className='total-input-box'>
                                                                                <input
                                                                                    className={`card-four-table-input-price form-control ${Number(lineTotal) > 0 ? 'has-total' : ''}`}
                                                                                    value={lineTotal}
                                                                                    readOnly
                                                                                />
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}
                                                    </React.Fragment>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                    {!loading && category.length > 0 && (
                                        <div className="onpage-checkout-section">
                                            <div className="row g-4">
                                                {/* Order Summary & Cart Totals */}
                                                <div className="col-12 col-lg-5">
                                                    <div className="onpage-summary-box h-100 d-flex flex-column justify-content-between">
                                                        <div>
                                                            <div className="d-flex align-items-center justify-content-between mb-3 border-bottom pb-2">
                                                                <h5 className="fw-bold mb-0 text-dark d-flex align-items-center gap-2">
                                                                    <FaShoppingCart color="#0b0960" /> Order Summary
                                                                </h5>
                                                                <span className="badge bg-danger rounded-pill px-3 py-2 fs-6">
                                                                    {totals.totalProducts} Items
                                                                </span>
                                                            </div>

                                                            <div className="table-responsive">
                                                                <table className="table table-borderless mb-0">
                                                                    <tbody>
                                                                        <tr className="border-bottom">
                                                                            <td className="text-muted py-2">Total MRP Rate :</td>
                                                                            <td className="text-end fw-semibold py-2">₹ {totals.overallTotal.toFixed(2)}</td>
                                                                        </tr>
                                                                        <tr className="border-bottom">
                                                                            <td className="text-success py-2">Total Discount (80%) :</td>
                                                                            <td className="text-end text-success fw-semibold py-2">
                                                                                - ₹ {totals.discountedOverallTotal.toFixed(2)}
                                                                            </td>
                                                                        </tr>
                                                                        <tr className="border-bottom bg-white">
                                                                            <td className="fw-bold fs-5 py-2 text-dark">Total Amount :</td>
                                                                            <td className="text-end fw-bold fs-5 py-2 text-danger">
                                                                                ₹ {totals.discountRate.toFixed(2)}
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>

                                                            <div className="alert alert-info py-2 px-3 mt-3 d-flex align-items-center justify-content-between mb-0">
                                                                <span className="small fw-semibold">Minimum Order Amount :</span>
                                                                <span className="badge bg-primary fs-6">₹ 3000</span>
                                                            </div>

                                                            {totals.discountRate < 3000 && totals.totalProducts > 0 && (
                                                                <div className="alert alert-warning py-2 px-3 mt-2 small mb-0">
                                                                    ⚠️ Add ₹ {(3000 - totals.discountRate).toFixed(2)} more to meet the minimum order requirement.
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div className="mt-3 pt-2 border-top text-center">
                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-dark w-100 py-2 d-flex align-items-center justify-content-center gap-2 fw-bold"
                                                                onClick={handleShowCart}
                                                            >
                                                                <FaShoppingCart /> View / Edit Cart Items ({totals.totalProducts})
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Customer Details Form */}
                                                <div className="col-12 col-lg-7">
                                                    <div className="p-3 bg-white rounded-3 border">
                                                        <h5 className="fw-bold mb-3 text-dark border-bottom pb-2">
                                                            Customer Details (Order Enquiry)
                                                        </h5>

                                                        <Row>
                                                            <Col md="6" className="py-2">
                                                                <DropDowns
                                                                    options={Object.keys(districtData).map(state => ({ value: state, label: state }))}
                                                                    placeholder={"Select State"}
                                                                    label={"Select State *"}
                                                                    name="state"
                                                                    value={{ value: formData.state, label: formData.state || "Select State" }}
                                                                    onChange={handleStateChange}
                                                                />
                                                            </Col>
                                                            <Col md="6" className="py-2">
                                                                <DropDowns
                                                                    options={cityOptions}
                                                                    placeholder={"Select City"}
                                                                    label={"Select City *"}
                                                                    name="city"
                                                                    value={{ value: formData.city, label: formData.city || "Select City" }}
                                                                    onChange={handleCityChange}
                                                                />
                                                            </Col>
                                                            <Col md="6" className="py-2">
                                                                <Forms
                                                                    placeholder={"Enter your Name"}
                                                                    label={"Full Name *"}
                                                                    name="name"
                                                                    value={formData.name}
                                                                    onChange={(e) => handleChange(e, 'name')}
                                                                />
                                                            </Col>
                                                            <Col md="6" className="py-2">
                                                                <Forms
                                                                    placeholder={"Enter Mobile Number"}
                                                                    label={"Mobile Number *"}
                                                                    name="mobile"
                                                                    value={formData.mobile}
                                                                    onChange={(e) => handleChange(e, 'mobile')}
                                                                />
                                                            </Col>
                                                            <Col md="6" className="py-2">
                                                                <Forms
                                                                    placeholder={"Enter Email Address (Optional)"}
                                                                    label={"Email Address (Optional)"}
                                                                    name="email"
                                                                    value={formData.email}
                                                                    onChange={(e) => handleChange(e, 'email')}
                                                                />
                                                            </Col>
                                                            <Col md="6" className="py-2">
                                                                <Forms
                                                                    placeholder={"Reference Name (Optional)"}
                                                                    label={"Reference Name (Optional)"}
                                                                    name="reference_name"
                                                                    value={formData.reference_name}
                                                                    onChange={(e) => handleChange(e, 'reference_name')}
                                                                />
                                                            </Col>
                                                            <Col md="6" className="py-2">
                                                                <Forms
                                                                    placeholder={"Reference Number (Optional)"}
                                                                    label={"Reference Number (Optional)"}
                                                                    name="reference_number"
                                                                    value={formData.reference_number}
                                                                    onChange={(e) => handleChange(e, 'reference_number')}
                                                                />
                                                            </Col>
                                                            <Col md="12" className="py-2">
                                                                <div className="py-1">
                                                                    <label className="fw-semibold text-secondary small">Delivery Address</label>
                                                                </div>
                                                                <textarea
                                                                    placeholder="Enter complete address for parcel delivery"
                                                                    className="form-control"
                                                                    rows={3}
                                                                    name="address"
                                                                    value={formData.address}
                                                                    onChange={(e) => handleChange(e, 'address')}
                                                                />
                                                            </Col>
                                                        </Row>

                                                        {isSubmitting && (
                                                            <div className="text-center py-2 fw-bold text-danger">
                                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                                Submitting your order enquiry, please wait...
                                                            </div>
                                                        )}

                                                        <div className="mt-3">
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger btn-lg w-100 py-3 fw-bold onpage-submit-btn text-uppercase"
                                                                onClick={handleSubmit}
                                                                disabled={isSubmitting}
                                                            >
                                                                {isSubmitting ? (
                                                                    <span className="d-flex align-items-center justify-content-center">
                                                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                                        Submitting...
                                                                    </span>
                                                                ) : (
                                                                    <>Submit Order Enquiry</>
                                                                )}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
                <>
                    <Modal show={show} onHide={handleClose} centered>
                        <Modal.Header closeButton>
                            <Modal.Title><div> {selectedProduct && selectedProduct.product_name}</div></Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <table>
                                <tbody>
                                    <tr>
                                        <td class="text-center image_video" colspan="2">
                                            <div className='text-center mx-auto'>
                                                {selectedProduct && (
                                                    selectedProduct.img ? (
                                                        <img src={selectedProduct.img} className='img-fluid' alt='Product' />
                                                    ) : (
                                                        <img src={require('../../assets/images/storelogo.png')} className='img-fluid' alt='product' />
                                                    )
                                                )}
                                            </div>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </Modal.Body>
                        <Modal.Footer className='mx-auto'>
                            <table>
                                <tbody>
                                    <tr>
                                        {selectedProduct && selectedProduct.img && (
                                            <td>
                                                <div className='dual'>
                                                    <img src={selectedProduct.img} className='img-fluid' alt='product' />
                                                </div>
                                            </td>
                                        )}
                                        {selectedProduct && selectedProduct.video_url && (
                                            <td>
                                                <div className='w-25 mx-auto'>
                                                    <div className='play-icon' onClick={handleVideoModalShow}>
                                                        <FaPlay />
                                                    </div>
                                                </div>
                                            </td>
                                        )}
                                    </tr>
                                </tbody>
                            </table>
                        </Modal.Footer>
                    </Modal>
                    {showVideoModal && (
                        <Modal show={showVideoModal} onHide={handleVideoModalClose} centered>
                            <Modal.Header closeButton>
                                <Modal.Title>{selectedProduct && selectedProduct.product_name}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <iframe
                                    width="100%"
                                    height="400"
                                    src={`https://www.youtube.com/embed/${extractVideoId(selectedProduct.video_url)}`}
                                    frameBorder="0"
                                    allowFullScreen
                                    title="Product Video"
                                />
                            </Modal.Body>
                        </Modal>
                    )}
                </>
                <>
                    <Offcanvas show={showCart} onHide={handleCloseCart} scroll="true" placement='end'>
                        <PageTitle onClick={handleCloseCart} title={companydata.company_name} address={companydata.address} phone={companydata.phone} />
                        <Offcanvas.Body>
                            <div className='canvas-table'>
                                <div className='cart-table'>
                                    <BootstrapTable>
                                        <tbody>
                                            {cart.map(cartItem => (
                                                <tr key={cartItem.id}>
                                                    <td className='w-75'>
                                                        <div className='product-name pb-2'>{cartItem.product_name}</div>
                                                        <div className='cart-qty-box d-flex align-items-center'>
                                                            <button
                                                                type="button"
                                                                className='cart-qty-btn cart-qty-btn-minus'
                                                                onClick={() => {
                                                                    const currentQty = parseInt(cartItem.qty, 10) || 0;
                                                                    handleQuantityChange(cartItem.id, Math.max(0, currentQty - 1), getItemDiscount(cartItem));
                                                                }}
                                                                title="Decrease quantity"
                                                            >
                                                                <FaMinus size={10} />
                                                            </button>
                                                            <input
                                                                type='number'
                                                                min='0'
                                                                className='cart-qty-input form-control text-center'
                                                                value={cartItem.qty}
                                                                onChange={(e) => handleQuantityChange(cartItem.id, e.target.value, getItemDiscount(cartItem))}
                                                            />
                                                            <button
                                                                type="button"
                                                                className='cart-qty-btn cart-qty-btn-plus'
                                                                onClick={() => {
                                                                    const currentQty = parseInt(cartItem.qty, 10) || 0;
                                                                    handleQuantityChange(cartItem.id, currentQty + 1, getItemDiscount(cartItem));
                                                                }}
                                                                title="Increase quantity"
                                                            >
                                                                <FaPlus size={10} />
                                                            </button>
                                                        </div>
                                                    </td>
                                                    <td className='text-end'>
                                                        <div className='pb-2'> <Close label={<><FaTimes /></>} onClick={() => removeProduct(cartItem.id)} /> </div>
                                                        <div className='price_total'>₹<span>{Math.round(cartItem.total_price)}</span></div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </BootstrapTable>
                                </div>
                            </div>
                            <div className='bottom-table'>
                                <BootstrapTable>
                                    <tr>
                                        <td>
                                            <tr>
                                                <td className='w-100'>Total MRP rate :</td>
                                                <td> ₹<span>{totals.overallTotal.toFixed(2)}</span></td>
                                            </tr>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <tr>
                                                <td className='w-100'>Total Discount Amount (80%) :</td>
                                                <td> ₹<span>{(totals.discountedOverallTotal).toFixed(2)}</span></td>
                                            </tr>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <tr>
                                                <td className='w-100'>Total Amount :</td>
                                                <td> ₹<span>{(totals.discountRate).toFixed(2)}</span></td>
                                            </tr>
                                        </td>
                                    </tr>
                                </BootstrapTable>
                            </div>

                            <div className='text-center'>
                                {totals.discountRate >= "3000" && (
                                    <div className='text-center regular py-3'>
                                        <Buttons label={<>Confirm Estimate</>} fullWidth={'100%'}
                                            onClick={() => {
                                                showOut();
                                                handleCloseCart();
                                            }}
                                        ></Buttons>
                                    </div>
                                )}
                                <div className='py-2'>
                                    Min Order : ₹<span>3000</span>
                                </div>
                            </div>
                        </Offcanvas.Body>
                    </Offcanvas>
                </>
                <>
                    <Offcanvas show={checkout} scroll="true" placement='end'>
                        <PageTitle onClick={closeOut} title={companydata.company_name} />
                        <Offcanvas.Body>
                            <div className='customer-details'>
                                <div className='canvas-table'>
                                    <Container>
                                        <Row>
                                            <Col lg='12' className='py-2'>
                                                <DropDowns
                                                    options={Object.keys(districtData).map(state => ({ value: state, label: state }))}
                                                    placeholder={"Select State"}
                                                    label={"Select State"}
                                                    name="state"
                                                    value={{ value: formData.state, label: formData.state }}
                                                    onChange={handleStateChange}
                                                />
                                            </Col>                                        <Col lg='12' className='py-2'>
                                                <DropDowns
                                                    options={cityOptions}
                                                    placeholder={"Select City"}
                                                    label={"Select City"}
                                                    name="city"
                                                    value={{ value: formData.city, label: formData.city }}
                                                    onChange={handleCityChange}
                                                />
                                            </Col>
                                            {/* <Col lg='12' className='py-2'>
                                            <Forms
                                                placeholder={"Enter the State"}
                                                label={"Enter the State"}
                                                name="state"
                                                value={formData.state}
                                                onChange={(e) => handleChange(e, 'state')}
                                            />
                                        </Col>
                                        <Col lg='12' className='py-2'>
                                            <Forms
                                                placeholder={"Enter the City"}
                                                label={"Enter the City"}
                                                name="city"
                                                value={formData.city}
                                                onChange={(e) => handleChange(e, 'city')}
                                            />
                                        </Col> */}
                                            <Col lg='12' className='py-2'>
                                                <Forms
                                                    placeholder={"Enter the name"}
                                                    label={"Enter the Name"}
                                                    name="name"
                                                    value={formData.name}
                                                    onChange={(e) => handleChange(e, 'name')}
                                                />
                                            </Col>
                                            <Col lg='12' className='py-2'>
                                                <Forms
                                                    placeholder={"Enter the Mail"}
                                                    label={"Enter the Mail"}
                                                    name="email"
                                                    value={formData.email}
                                                    onChange={(e) => handleChange(e, 'email')}
                                                />
                                            </Col>
                                            <Col lg='12' className='py-2'>
                                                <Forms
                                                    placeholder={"Mobile No."}
                                                    label={"Mobile No."}
                                                    name="mobile"
                                                    value={formData.mobile}
                                                    onChange={(e) => handleChange(e, 'mobile')}
                                                />
                                            </Col>
                                            <Col lg='12' className='py-2'>
                                                <Forms
                                                    placeholder={"Reference Name (Optional)"}
                                                    label={"Reference Name (Optional)"}
                                                    name="reference_name"
                                                    value={formData.reference_name}
                                                    onChange={(e) => handleChange(e, 'reference_name')}
                                                />
                                            </Col>
                                            <Col lg='12' className='py-2'>
                                                <Forms
                                                    placeholder={"Reference Number (Optional)"}
                                                    label={"Reference Number (Optional)"}
                                                    name="reference_number"
                                                    value={formData.reference_number}
                                                    onChange={(e) => handleChange(e, 'reference_number')}
                                                />
                                            </Col>
                                            <Col lg='12' className='py-2'>
                                                <div className='py-2'> <label> Address</label></div>
                                                <textarea
                                                    placeholder='Address'
                                                    className='w-100'
                                                    name="address"
                                                    value={formData.address}
                                                    onChange={(e) => handleChange(e, 'address')}
                                                />
                                            </Col>
                                        </Row>
                                    </Container>
                                </div>
                                <div className='bottom-table'>
                                    <BootstrapTable>
                                        <tr>
                                            <td>
                                                <tr>
                                                    <td className='w-100'>Total MRP rate :</td>
                                                    <td> ₹<span>{totals.overallTotal.toFixed(2)}</span></td>
                                                </tr>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <tr>
                                                    <td className='w-100'>Total Discount Amount (80%) :</td>
                                                    <td> ₹<span>{(totals.discountedOverallTotal).toFixed(2)}</span></td>
                                                </tr>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <tr>
                                                    <td className='w-100'>Total Amount :</td>
                                                    <td> ₹<span>{(totals.discountRate).toFixed(2)}</span></td>
                                                </tr>
                                            </td>
                                        </tr>
                                    </BootstrapTable>
                                </div>
                                {isSubmitting && (
                                    <div className='text-center py-2 fw-bold' style={{ color: '#e51e25', fontSize: '15px' }}>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Submitting your order, please wait...
                                    </div>
                                )}
                                <div className='d-flex justify-content-evenly'>
                                    <div className='text-center regular py-3 w-100 mx-2'>
                                        <Buttons
                                            label={
                                                isSubmitting ? (
                                                    <span className="d-flex align-items-center justify-content-center">
                                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                        Submitting...
                                                    </span>
                                                ) : (
                                                    <>Submit</>
                                                )
                                            }
                                            className="w-100"
                                            fullWidth={"100%"}
                                            onClick={handleSubmit}
                                            disabled={isSubmitting}
                                        ></Buttons>
                                    </div>
                                    <div className='text-center regular py-3 w-100 mx-2'>
                                        <Buttons
                                            label={<>Cancel</>}
                                            fullWidth={"100%"}
                                            onClick={closeOut}
                                            disabled={isSubmitting}
                                        ></Buttons>
                                    </div>
                                </div>
                            </div>
                        </Offcanvas.Body>
                    </Offcanvas>
                    <>
                        <Modal show={showEstimate} onHide={closeModal} centered className='regular' size='lg'>
                            <Modal.Header closeButton className='bg-primary text-white'>
                                <Modal.Title className='bold text-white d-flex align-items-center gap-2'>
                                    🎉 Order Estimated Successfully!
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body className='p-4'>
                                <Container fluid>
                                    <Row className='g-4 align-items-center'>
                                        {/* Order & Company Overview */}
                                        <Col lg="6" md="12">
                                            <div className='p-3 bg-light rounded-3 border h-100'>
                                                <h5 className='bold text-dark mb-2'>{companydata.company_name || 'GMR Crackers'}</h5>
                                                <p className='regular text-muted small mb-2 lh-sm'>
                                                    {companydata.address || 'D. No: 3/347c1/1, Maraneri, Sivakasi to Alangulam Main Road, Sivakasi - 626124'}
                                                </p>
                                                <div className='small text-muted mb-3'>
                                                    <strong>Helpline:</strong> {companydata.phone || '+91 98430 58048 / +91 73588 66226'}
                                                </div>

                                                <hr className='my-2' />

                                                {submittedOrder?.enquiryNo && (
                                                    <div className='d-flex justify-content-between py-1'>
                                                        <span className='text-muted small'>Enquiry No:</span>
                                                        <strong className='bold text-primary small'>#{submittedOrder.enquiryNo}</strong>
                                                    </div>
                                                )}
                                                <div className='d-flex justify-content-between py-1'>
                                                    <span className='text-muted small'>Customer:</span>
                                                    <strong className='bold small'>
                                                        {submittedOrder ? `${submittedOrder.name} (${submittedOrder.mobile})` : `${formData.name} (${formData.mobile})`}
                                                    </strong>
                                                </div>
                                                <div className='d-flex justify-content-between py-1'>
                                                    <span className='text-muted small'>Total Products:</span>
                                                    <span className='badge bg-danger rounded-pill'>
                                                        {submittedOrder?.totalProducts !== undefined ? submittedOrder.totalProducts : totals.totalProducts} Items
                                                    </span>
                                                </div>
                                                <div className='d-flex justify-content-between py-1 border-top mt-2 pt-2'>
                                                    <strong className='bold text-dark fs-6'>Total Payable:</strong>
                                                    <strong className='bold text-danger fs-5'>
                                                        ₹ {(submittedOrder?.discountRate !== undefined ? submittedOrder.discountRate : totals.discountRate).toFixed(2)}
                                                    </strong>
                                                </div>

                                                <div className='alert alert-success small py-2 px-3 mt-3 mb-0'>
                                                    ✓ Your estimate has been submitted! Our team will contact you within 24 hrs to confirm dispatch.
                                                </div>
                                            </div>
                                        </Col>

                                        {/* Google Pay / UPI QR Code Card */}
                                        <Col lg="6" md="12" className='text-center'>
                                            <div className='p-3 bg-white rounded-3 border shadow-sm'>
                                                <span className='badge bg-danger text-white bold px-3 py-1 rounded-pill mb-2'>
                                                    Scan to Pay Advance / Bill
                                                </span>
                                                <div className='bold text-dark small mb-2'>
                                                    Total Payable: <span className='text-danger fw-bold fs-6'>₹ {(submittedOrder?.discountRate !== undefined ? submittedOrder.discountRate : totals.discountRate).toFixed(2)}</span>
                                                </div>
                                                <div className='qr-box p-2 bg-light rounded-3 border d-inline-block shadow-sm mb-2' style={{ width: '100%', maxWidth: '210px' }}>
                                                    <img
                                                        src={require('../../assets/images/gpay_qr.jpg')}
                                                        alt="GMR Crackers Google Pay QR"
                                                        className='img-fluid rounded'
                                                        style={{ width: '100%', height: 'auto', objectFit: 'contain', display: 'block' }}
                                                    />
                                                </div>
                                                <div className='bold text-dark small mb-1'>
                                                    UPI ID: <span className='text-danger'>rakeshmahesh2010-1@okaxis</span>
                                                </div>
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        navigator.clipboard.writeText("rakeshmahesh2010-1@okaxis");
                                                        setModalCopied(true);
                                                        setTimeout(() => setModalCopied(false), 2000);
                                                    }}
                                                    className={`btn btn-sm ${modalCopied ? 'btn-success' : 'btn-outline-primary'} py-1 px-3 rounded-pill bold mb-2`}
                                                >
                                                    {modalCopied ? <><FaCheck /> UPI ID Copied!</> : <><FaCopy /> Copy UPI ID</>}
                                                </button>
                                                <div className='text-muted' style={{ fontSize: '11.5px' }}>
                                                    Pay using GPay, PhonePe, Paytm, or BHIM
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Container>
                            </Modal.Body>
                            <Modal.Footer className='d-flex justify-content-between flex-wrap gap-2'>
                                <a
                                    href={`https://wa.me/919843058048?text=Hello%20GMR%20Crackers,%20I%20have%20submitted%20an%20order%20for%20Rs.${(submittedOrder?.discountRate !== undefined ? submittedOrder.discountRate : totals.discountRate).toFixed(2)}.%20Name:%20${encodeURIComponent(submittedOrder?.name || formData.name)},%20Mobile:%20${submittedOrder?.mobile || formData.mobile}${submittedOrder?.enquiryNo ? `,%20Enquiry%20No:%20${submittedOrder.enquiryNo}` : ''}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className='btn btn-success d-flex align-items-center gap-2 bold rounded-pill px-3 py-2'
                                >
                                    <FaWhatsapp size={18} /> Confirm on WhatsApp
                                </a>

                                <div className='d-flex gap-2'>
                                    <PDFDownloadLink document={<Bill data={printData} />} fileName="estimate.pdf">
                                        {({ loading }) => (
                                            loading
                                                ? <button className='btn btn-primary rounded-pill px-4 py-2 bold' disabled>Generating PDF...</button>
                                                : <button className='btn btn-primary rounded-pill px-4 py-2 bold'>📄 Download PDF</button>
                                        )}
                                    </PDFDownloadLink>
                                    <button onClick={closeModal} className='btn btn-secondary rounded-pill px-4 py-2 bold'>
                                        Done
                                    </button>
                                </div>
                            </Modal.Footer>
                        </Modal>
                    </>
                </>
                <ToastContainer
                    position="top-center"
                    autoClose={2000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="colored"
                />
            </div>
        </>

    )
}

export default CardFour